import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

export interface UsuarioPorEquipe {
  idUsuario: string;
  nome: string;
  cargo: string;
  idEquipe: string;
  nomeEquipe: string;
}

interface ListarSuperintendentesProps extends QueryGlobalInterface {
  userId: string;
  enabled?: boolean;
}

interface ListarEquipesProps extends QueryGlobalInterface {
  IdsSuperintendentes: string[];
  enabled?: boolean;
}

interface ListarCorretoresProps extends QueryGlobalInterface {
  IdsEquipes: string[];
  enabled?: boolean;
}

const fetchUsuariosPorEquipe = async (IdsUsuarioLider: string[]) => {
  let url = "identity/usuario/v1/listar-usuarios-por-equipe";

  if (IdsUsuarioLider.length > 0) {
    url += "?";
    const params = IdsUsuarioLider.filter((id) => id && id.trim() !== "")
      .map((id) => `IdsUsuarioLider=${encodeURIComponent(id)}`)
      .join("&");
    url += params;
  }

  const response = await instance.get(url);
  return response?.data || null;
};

export function useListarSuperintendentes(props: ListarSuperintendentesProps) {
  const fetchData = async () => {
    return fetchUsuariosPorEquipe([props.userId ?? ""]);
  };

  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: props.enabled !== undefined ? props.enabled : false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar superintendentes. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return query;
}

export function useListarEquipes(props: ListarEquipesProps) {
  const fetchData = async () => {
    return fetchUsuariosPorEquipe(props.IdsSuperintendentes);
  };

  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled:
      props.enabled !== undefined
        ? props.enabled && props.IdsSuperintendentes.length > 0
        : props.IdsSuperintendentes.length > 0,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar equipes. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return query;
}

export function useListarCorretores(props: ListarCorretoresProps) {
  const fetchData = async () => {
    return fetchUsuariosPorEquipe(props.IdsEquipes);
  };

  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled:
      props.enabled !== undefined
        ? props.enabled && props.IdsEquipes.length > 0
        : props.IdsEquipes.length > 0,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar corretores. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return query;
}
